var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVEngagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#82BD57;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st0",
    d: "M154.5,86.6c-2.1,0-3.8-1.7-3.8-3.8V61.1c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v21.7 C158.3,84.9,156.6,86.6,154.5,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st0",
    d: "M137.4,86.6c-2.1,0-3.8-1.7-3.8-3.8V43.1c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v39.6 C141.2,84.9,139.5,86.6,137.4,86.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M120.3,86.4c-2.1,0-3.8-1.7-3.8-3.8V43.1c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v39.4 C124.1,84.7,122.4,86.4,120.3,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st0",
    d: "M120.3,133.8c-2,0-3.7-1.6-3.8-3.6c-0.7-11.9-13.3-13.8-13.8-13.9c-1.9-0.3-3.3-1.9-3.3-3.8 V79.3c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v30.2c6.9,2,16.4,7.8,17.1,20.3c0.1,2.1-1.5,3.9-3.6,4 C120.4,133.7,120.4,133.8,120.3,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st0",
    d: "M132,260.8H99.1c-2.1,0-3.8-1.7-3.8-3.8v-84.9c0-2.1,1.7-3.8,3.8-3.8h32.9 c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8h-29.1v77.3H132c2.1,0,3.8,1.7,3.8,3.8C135.8,259.1,134.1,260.8,132,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st0",
    d: "M156.2,144.6c-2.1,0-3.8-1.7-3.8-3.8v-17.4c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v17.4 C159.9,142.9,158.3,144.6,156.2,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st0",
    d: "M169.9,144.6c-2.1,0-3.8-1.7-3.8-3.8V109c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v31.8 C173.7,142.9,172,144.6,169.9,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M183.6,144.4c-2.1,0-3.8-1.7-3.8-3.8V109c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v31.6 C187.4,142.7,185.7,144.4,183.6,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st0",
    d: "M183.6,182.4c-0.1,0-0.2,0-0.2,0c-2.1-0.1-3.7-1.9-3.6-4c0.6-10,8-14.9,13.7-16.8V138 c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v26.6c0,1.9-1.4,3.5-3.3,3.8c-1,0.1-9.9,1.7-10.4,10.4 C187.3,180.9,185.6,182.4,183.6,182.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st0",
    d: "M197.4,216.3h-49c-2.1,0-3.8-1.7-3.8-3.8v-9.8c0-6.5-1-13-2.9-19.2l-2.8-9 c-0.1-0.4-0.2-0.7-0.2-1.1v-49.6c0-5.4,3.7-10,8.8-10.9c1.7-0.3,3.4-0.2,5,0.3v-3.8c0-5.4,3.7-10,8.8-10.9c1.9-0.3,3.9-0.2,5.6,0.5 c1.3-3.6,4.3-6.4,8.1-7c3.1-0.6,6.3,0.3,8.8,2.3c1.5,1.3,2.6,2.9,3.2,4.7c1.8-0.6,3.7-0.8,5.6-0.5c5.1,0.9,8.8,5.5,8.8,10.9v17.1 c1.9-0.8,4-1.2,6.2-1c6.4,0.6,11.5,6.3,11.5,13v26.6c0,6.3-2.4,12.3-6.6,16.9l-11,11.8v18.7C201.1,214.6,199.4,216.3,197.4,216.3z M152.1,208.7h41.5v-16.4c0-1,0.4-1.9,1-2.6l12-12.9c3-3.2,4.6-7.4,4.6-11.7v-26.6c0-2.8-2.1-5.3-4.6-5.5c-1.4-0.1-2.8,0.3-3.9,1.3 c-1.1,1-1.6,2.3-1.6,3.7c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8v-28.6c0-1.7-1.1-3.1-2.5-3.4c-1.3-0.2-2.2,0.3-2.6,0.7 c-0.7,0.6-1.1,1.4-1.1,2.4c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8v-6.5c0-0.9-0.4-1.8-1.1-2.4c-0.4-0.3-1.3-0.9-2.6-0.7 c-1.4,0.2-2.5,1.7-2.5,3.4v6.2c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-0.9-0.4-1.8-1.1-2.4c-0.4-0.3-1.3-0.9-2.6-0.7 c-1.4,0.2-2.5,1.7-2.5,3.4v14c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-0.9-0.4-1.8-1.1-2.4c-0.4-0.3-1.3-0.9-2.6-0.7 c-1.4,0.2-2.5,1.7-2.5,3.4v49l2.6,8.5c2.2,6.9,3.2,14.2,3.2,21.4V208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M200.6,260.8H145c-2.1,0-3.8-1.7-3.8-3.8v-44.6c0-2.1,1.7-3.8,3.8-3.8h55.6 c2.1,0,3.8,1.7,3.8,3.8V257C204.4,259.1,202.7,260.8,200.6,260.8z M148.8,253.2h48v-37h-48V253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M129.3,175.9h-26.1c-2.1,0-3.8-1.7-3.8-3.8v-23.7l-14-15c-5.2-5.6-8-12.8-8-20.4V79.9 c0-7.9,5.9-14.7,13.5-15.3c3-0.3,6,0.4,8.5,1.8V43.6c0-6.3,4.3-11.6,10.1-12.6c2.5-0.4,5.1-0.1,7.4,0.9c0.6-2.5,2-4.7,4-6.4 c2.8-2.4,6.5-3.3,10.2-2.7c4.7,0.8,8.4,4.5,9.7,9.1c2.3-1.1,4.9-1.4,7.4-1c5.9,1,10.1,6.3,10.1,12.6v6.1c2.2-0.9,4.6-1.2,7-0.8 c5.9,1,10.1,6.3,10.1,12.6v24.5c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8V61.5c0-2.5-1.7-4.8-3.9-5.1c-1.5-0.3-2.9,0.1-4,1 c-1.1,0.9-1.7,2.2-1.7,3.7c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8V43.6c0-2.5-1.7-4.8-3.9-5.1c-1.5-0.3-2.9,0.1-4,1 c-1.1,0.9-1.7,2.2-1.7,3.7c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8v-7.7c0-2.5-1.7-4.8-3.9-5.1c-1.5-0.3-2.9,0.1-4,1 c-1.1,0.9-1.7,2.2-1.7,3.7v8.2c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-1.4-0.6-2.7-1.7-3.7c-1.1-0.9-2.5-1.3-4-1 c-2.2,0.4-3.9,2.6-3.9,5.1v35.7c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2-0.8-3.9-2.3-5.3c-1.5-1.4-3.5-2-5.5-1.9 c-3.7,0.3-6.6,3.7-6.6,7.8V113c0,5.7,2.1,11.1,6,15.3l15,16.1c0.7,0.7,1,1.6,1,2.6v21.4h22.3c2.1,0,3.8,1.7,3.8,3.8 C133.1,174.2,131.4,175.9,129.3,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M76.3,160.5c-2.1,0-3.8-1.7-3.8-3.8V154c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v2.6 C80.1,158.8,78.4,160.5,76.3,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M84.2,165.7h-2.6c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8h2.6c2.1,0,3.8,1.7,3.8,3.8 C88,164,86.3,165.7,84.2,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M76.3,173.5c-2.1,0-3.8-1.7-3.8-3.8v-2.6c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v2.6 C80.1,171.8,78.4,173.5,76.3,173.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M71.1,165.7h-2.6c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8h2.6c2.1,0,3.8,1.7,3.8,3.8 C74.9,164,73.2,165.7,71.1,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M205.6,63.5c-2.1,0-3.8-1.7-3.8-3.8V57c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v2.6 C209.4,61.8,207.7,63.5,205.6,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M213.5,68.7h-2.6c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8h2.6c2.1,0,3.8,1.7,3.8,3.8 C217.3,67,215.6,68.7,213.5,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M205.6,76.5c-2.1,0-3.8-1.7-3.8-3.8v-2.6c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v2.6 C209.4,74.9,207.7,76.5,205.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M200.4,68.7h-2.6c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8h2.6c2.1,0,3.8,1.7,3.8,3.8 C204.2,67,202.5,68.7,200.4,68.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVEngagement);
export default __webpack_public_path__ + "static/media/V-engagement.8d28a5f5d7c7ceac404f058b213d3b39.svg";
export { ForwardRef as ReactComponent };